import {
  grid as iconGrid,
  justifySpaceBetween as iconJustifyBetween,
  justifyLeft as iconJustifyLeft,
  justifyCenter as iconJustifyCenter,
  justifyRight as iconJustifyRight,
} from '@wordpress/icons';

if (typeof wp.data != 'undefined' && typeof wp.blocks != 'undefined') {

// Row Block

(function(wp) {
  var el = wp.element.createElement;
  let registerBlockType = wp.blocks.registerBlockType;
  var useBlockProps = wp.blockEditor.useBlockProps;
  var InnerBlocks = wp.blockEditor.InnerBlocks;

  registerBlockType('theme/grid', {
    title: 'Grid',
    category: 'design',
    icon: iconGrid,
    edit: function(props) {
      // let blockProps = useBlockProps();

      // if (typeof props.className === 'undefined') {
      //   props.className = '';
      // }

      return el('div', props,
        el(InnerBlocks, {
          allowedBlocks: [
            'theme/container',
            'acf/block-stat'
          ],
          template: [
            [ 'theme/container', {} ],
            [ 'theme/container', {} ],
          ],
        })
      )
    },
    save: function(attributes) {
      let blockProps = useBlockProps.save();

      return el('div', blockProps,
        el(InnerBlocks.Content)
      )
    }
  } );
})(window.wp);

// Row Controls

(function (wp) {
  var el = wp.element.createElement;
  var Fragment = wp.element.Fragment;
  var InspectorControls = wp.blockEditor.InspectorControls;
  var PanelBody = wp.components.PanelBody;
  var PanelRow = wp.components.PanelRow;

  var ToggleGroupControl = wp.components.__experimentalToggleGroupControl;
  var ToggleGroupControlOption = wp.components.__experimentalToggleGroupControlOption;
  var ToggleGroupControlOptionIcon = wp.components.__experimentalToggleGroupControlOptionIcon;

  var allowedBlocks = [
    'theme/grid',
  ];

  function addAttributes(settings) {
    if (typeof settings.attributes !== 'undefined' && allowedBlocks.includes(settings.name)) {
      settings.attributes = Object.assign(settings.attributes, {
        themeColumnsMD: {
          type: 'string',
          default: '2'
        },
        themeColumnsLG: {
          type: 'string',
          default: '3'
        },
        themeColumnsXL: {
          type: 'string',
          default: '3'
        },
        themeAlign: {
          type: 'string',
          default: 'start'
        },
      });
    }

    return settings;
  }

  var withInspectorControls = wp.compose.createHigherOrderComponent(function(BlockEdit) {
    return function(props) {
      if (!props.isSelected || !allowedBlocks.includes(props.name)) {
        return el(Fragment, {},
          el(BlockEdit, props)
        );
      }

      controls = el(InspectorControls, {},
        el(PanelBody, {
          title: 'Columns',
          initialOpen: true
        },
          el(PanelRow, {},
            el(ToggleGroupControl, {
              label: 'Tablet',
              className: 'toggle_group toggle_group_columns',
              value: props.attributes.themeColumnsMD,
              onChange: (val) => props.setAttributes({ themeColumnsMD: val }),
            },
              el(ToggleGroupControlOption, {
                label: '1',
                value: '1',
              }),
              el(ToggleGroupControlOption, {
                label: '2',
                value: '2',
              }),
              el(ToggleGroupControlOption, {
                label: '3',
                value: '3',
              }),
            ), // toggle group
          ),
          el(PanelRow, {},
            el(ToggleGroupControl, {
              label: 'Desktop - Small',
              className: 'toggle_group toggle_group_columns',
              value: props.attributes.themeColumnsLG,
              onChange: (val) => props.setAttributes({ themeColumnsLG: val }),
            },
              el(ToggleGroupControlOption, {
                label: '2',
                value: '2',
              }),
              el(ToggleGroupControlOption, {
                label: '3',
                value: '3',
              }),
              el(ToggleGroupControlOption, {
                label: '4',
                value: '4',
              }),
            ), // toggle group
          ),
          el(PanelRow, {},
            el(ToggleGroupControl, {
              label: 'Desktop - Large',
              className: 'toggle_group toggle_group_columns',
              value: props.attributes.themeColumnsXL,
              onChange: (val) => props.setAttributes({ themeColumnsXL: val }),
            },
              el(ToggleGroupControlOption, {
                label: '2',
                value: '2',
              }),
              el(ToggleGroupControlOption, {
                label: '3',
                value: '3',
              }),
              el(ToggleGroupControlOption, {
                label: '4',
                value: '4',
              }),
            ), // toggle group
          ),
          el(PanelRow, {},
            el(ToggleGroupControl, {
              label: 'Align',
              className: 'toggle_group toggle_group_align',
              value: props.attributes.themeAlign,
              onChange: (val) => props.setAttributes({ themeAlign: val }),
            },
              el(ToggleGroupControlOptionIcon, {
                label: 'Start',
                value: 'start',
                icon: iconJustifyLeft,
                size: 32,
              }, el(iconJustifyLeft)),
              el(ToggleGroupControlOptionIcon, {
                label: 'Center',
                value: 'center',
                icon: iconJustifyCenter,
              }),
              el(ToggleGroupControlOptionIcon, {
                label: 'End',
                value: 'end',
                icon: iconJustifyRight,
              }),
            ), // toggle group
          ),
        ),
      );

      return el(Fragment, {},
        el(BlockEdit, props),
        controls,
      );
    };
  }, 'withInspectorControls');

  var withCustomClassName = wp.compose.createHigherOrderComponent(function(BlockListBlock) {
    return function(props) {
      if (allowedBlocks.includes(props.name)) {
        if (typeof props.className === 'undefined') {
          props.className = '';
        }

        props.className = props.className.replace(/columns-md-1/g, '');
        props.className = props.className.replace(/columns-md-2/g, '');
        props.className = props.className.replace(/columns-md-3/g, '');

        if (typeof props.attributes.themeColumnsMD !== 'undefined') {
          let className = 'columns-md-' + props.attributes.themeColumnsMD;
          props.className += ' ' + className;
        }

        props.className = props.className.replace(/columns-lg-2/g, '');
        props.className = props.className.replace(/columns-lg-3/g, '');
        props.className = props.className.replace(/columns-lg-4/g, '');

        if (typeof props.attributes.themeColumnsLG !== 'undefined') {
          let className = 'columns-lg-' + props.attributes.themeColumnsLG;
          props.className += ' ' + className;
        }

        props.className = props.className.replace(/columns-xl-2/g, '');
        props.className = props.className.replace(/columns-xl-3/g, '');
        props.className = props.className.replace(/columns-xl-4/g, '');

        if (typeof props.attributes.themeColumnsXL !== 'undefined') {
          let className = 'columns-xl-' + props.attributes.themeColumnsXL;
          props.className += ' ' + className;
        }

        props.className = props.className.replace(/grid-align-start/g, '');
        props.className = props.className.replace(/grid-align-center/g, '');
        props.className = props.className.replace(/grid-align-end/g, '');

        if (typeof props.attributes.themeAlign !== 'undefined') {
          let className = 'grid-align-' + props.attributes.themeAlign;
          props.className += ' ' + className;
        }

        // console.log(props.attributes.themeAlign);
      }

      return el(BlockListBlock, props);
    };
  }, 'withInspectorControls');

  function applyExtraClass(extraProps, blockType, attributes) {
    if (allowedBlocks.includes(blockType.name)) {
      if (typeof extraProps.className === 'undefined') {
        extraProps.className = '';
      }

      extraProps.className = extraProps.className.replace(/columns-md-1/g, '');
      extraProps.className = extraProps.className.replace(/columns-md-2/g, '');
      extraProps.className = extraProps.className.replace(/columns-md-3/g, '');

      if (typeof attributes.themeColumnsMD !== 'undefined') {
        let className = 'columns-md-' + attributes.themeColumnsMD;
        extraProps.className += ' ' + className;
      }

      extraProps.className = extraProps.className.replace(/columns-lg-2/g, '');
      extraProps.className = extraProps.className.replace(/columns-lg-3/g, '');
      extraProps.className = extraProps.className.replace(/columns-lg-4/g, '');

      if (typeof attributes.themeColumnsLG !== 'undefined') {
        let className = 'columns-lg-' + attributes.themeColumnsLG;
        extraProps.className += ' ' + className;
      }

      extraProps.className = extraProps.className.replace(/columns-xl-2/g, '');
      extraProps.className = extraProps.className.replace(/columns-xl-3/g, '');
      extraProps.className = extraProps.className.replace(/columns-xl-4/g, '');

      if (typeof attributes.themeColumnsXL !== 'undefined') {
        let className = 'columns-xl-' + attributes.themeColumnsXL;
        extraProps.className += ' ' + className;
      }

      extraProps.className = extraProps.className.replace(/grid-align-start/g, '');
      extraProps.className = extraProps.className.replace(/grid-align-center/g, '');
      extraProps.className = extraProps.className.replace(/grid-align-end/g, '');

      if (typeof attributes.themeAlign !== 'undefined') {
        let className = 'grid-align-' + attributes.themeAlign;
        extraProps.className += ' ' + className;
      }

      // console.log('extra', attributes, attributes.themeAlign);
    }

    return extraProps;
  }

  wp.hooks.addFilter(
    'blocks.registerBlockType',
    'theme/theme-grid-attributes',
    addAttributes
  );

  wp.hooks.addFilter(
    'editor.BlockEdit',
    'theme/theme-grid-controls',
    withInspectorControls
  );

  wp.hooks.addFilter(
    'editor.BlockListBlock',
    'theme/theme-grid-class-admin',
    withCustomClassName
  );

  wp.hooks.addFilter(
    'blocks.getSaveContent.extraProps',
    'theme/theme-grid-class',
    applyExtraClass
  );
})(window.wp);

}
